import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : 'An unexpected error occurred';
    // Log sanitised error — no tokens or PII (SECURITY-03 / SECURITY-15)
    console.error('[CSD] Unhandled error:', message);
  }
}
